var _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarActivityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 128.14698162729658 128.14698162729658",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l128.14699 0l0 128.14699l-128.14699 0l0 -128.14699z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l128.14699 0l0 128.14699l-128.14699 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f3f3f3",
    d: "m5.1916013 5.1916013l117.76378 0l0 117.76378l-117.76378 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m5.1916013 5.1916013l117.76378 0l0 117.76378l-117.76378 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9900ff",
    d: "m5.6377954 5.4724407l116.88189 0l0 29.795275l-116.88189 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m5.6377954 5.4724407l116.88189 0l0 29.795275l-116.88189 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m28.015749 20.934383l0 0c0 -2.226534 1.8049622 -4.031496 4.031496 -4.031496l0 0c1.0692177 0 2.0946465 0.42474556 2.8506966 1.1807976c0.7560539 0.756052 1.1807976 1.7814789 1.1807976 2.8506985l0 0c0 2.226534 -1.8049622 4.031496 -4.031494 4.031496l0 0c-2.226534 0 -4.031496 -1.8049622 -4.031496 -4.031496z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m28.015749 20.934383l0 0c0 -2.226534 1.8049622 -4.031496 4.031496 -4.031496l0 0c1.0692177 0 2.0946465 0.42474556 2.8506966 1.1807976c0.7560539 0.756052 1.1807976 1.7814789 1.1807976 2.8506985l0 0c0 2.226534 -1.8049622 4.031496 -4.031494 4.031496l0 0c-2.226534 0 -4.031496 -1.8049622 -4.031496 -4.031496z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m92.07874 20.370079l0 0c0 -2.226534 1.8049622 -4.031496 4.031494 -4.031496l0 0c1.0692215 0 2.0946426 0.42474556 2.8507004 1.1807976c0.7560501 0.756052 1.1807938 1.7814789 1.1807938 2.8506985l0 0c0 2.226534 -1.8049622 4.031496 -4.031494 4.031496l0 0c-2.226532 0 -4.031494 -1.8049622 -4.031494 -4.031496z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m92.07874 20.370079l0 0c0 -2.226534 1.8049622 -4.031496 4.031494 -4.031496l0 0c1.0692215 0 2.0946426 0.42474556 2.8507004 1.1807976c0.7560501 0.756052 1.1807938 1.7814789 1.1807938 2.8506985l0 0c0 2.226534 -1.8049622 4.031496 -4.031494 4.031496l0 0c-2.226532 0 -4.031494 -1.8049622 -4.031494 -4.031496z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m12.563121 88.00484l0 0c0 -10.654312 8.637027 -19.291336 19.29134 -19.291336l0 0c5.1163807 0 10.023207 2.0324707 13.641035 5.650299c3.6178284 3.6178284 5.650303 8.524658 5.650303 13.641037l0 0c0 10.654312 -8.637028 19.291344 -19.291338 19.291344l0 0c-10.654312 0 -19.29134 -8.637032 -19.29134 -19.291344z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m12.563121 88.00484l0 0c0 -10.654312 8.637027 -19.291336 19.29134 -19.291336l0 0c5.1163807 0 10.023207 2.0324707 13.641035 5.650299c3.6178284 3.6178284 5.650303 8.524658 5.650303 13.641037l0 0c0 10.654312 -8.637028 19.291344 -19.291338 19.291344l0 0c-10.654312 0 -19.29134 -8.637032 -19.29134 -19.291344z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m77.00116 88.00484l0 0c0 -10.654312 8.637032 -19.291336 19.291344 -19.291336l0 0c5.116379 0 10.023209 2.0324707 13.641029 5.650299c3.6178284 3.6178284 5.6503067 8.524658 5.6503067 13.641037l0 0c0 10.654312 -8.637024 19.291344 -19.291336 19.291344l0 0c-10.654312 0 -19.291344 -8.637032 -19.291344 -19.291344z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m77.00116 88.00484l0 0c0 -10.654312 8.637032 -19.291336 19.291344 -19.291336l0 0c5.116379 0 10.023209 2.0324707 13.641029 5.650299c3.6178284 3.6178284 5.6503067 8.524658 5.6503067 13.641037l0 0c0 10.654312 -8.637024 19.291344 -19.291336 19.291344l0 0c-10.654312 0 -19.291344 -8.637032 -19.291344 -19.291344z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m95.922745 87.03576l-10.58268 -34.204727",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m95.922745 87.03576l-10.58268 -34.204727",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m56.73296 87.2401l-10.771652 -34.393703",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m56.73296 87.2401l-10.771652 -34.393703",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m56.251312 86.859024l31.527557 -26.61417",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m56.251312 86.859024l31.527557 -26.61417",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m87.60717 59.7274l-37.82677 6.1417313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m87.60717 59.7274l-37.82677 6.1417313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m31.130577 88.05485l18.80315 -21.826767",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m31.130577 88.05485l18.80315 -21.826767",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m30.886606 87.73928l26.425196 -1.3228302",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m30.886606 87.73928l26.425196 -1.3228302",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m87.902885 52.805775l-8.566925 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m87.902885 52.805775l-8.566925 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m39.36896 52.540665l0 0c0 -0.33340454 0.27028275 -0.6036873 0.6036873 -0.6036873l9.343807 0c0.16011047 0 0.31365967 0.06360626 0.42687225 0.17681885c0.113212585 0.113212585 0.17681503 0.26676178 0.17681503 0.42686844l0 2.4146767c0 0.33340454 -0.27027893 0.6036835 -0.6036873 0.6036835l-9.343807 0c-0.33340454 0 -0.6036873 -0.27027893 -0.6036873 -0.6036835z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m39.36896 52.540665l0 0c0 -0.33340454 0.27028275 -0.6036873 0.6036873 -0.6036873l9.343807 0c0.16011047 0 0.31365967 0.06360626 0.42687225 0.17681885c0.113212585 0.113212585 0.17681503 0.26676178 0.17681503 0.42686844l0 2.4146767c0 0.33340454 -0.27027893 0.6036835 -0.6036873 0.6036835l-9.343807 0c-0.33340454 0 -0.6036873 -0.27027893 -0.6036873 -0.6036835z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarActivityIcon);
export default __webpack_public_path__ + "static/media/calendar-activity-icon.c44ddad96c192b7a9c201f23238432d4.svg";
export { ForwardRef as ReactComponent };